import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';

enum TagType {
  NEW = 'NEW',
  ACTION = 'ACTION',
  LASTONSTOCK = 'LASTONSTOCK',
  LABEL = 'LABEL',
}

interface Props {
  text: string;
  type: string;
  theme?: any;
  style?: any;
}

function Tag({ text, type, theme, style }: Props) {
  const loadColorBasedOnItemType = () => {
    switch (type) {
      case TagType.NEW: {
        return theme.colors.white;
      }
      case TagType.ACTION: {
        return theme.colors.white;
      }
      case TagType.LASTONSTOCK: {
        return theme.colors.white;
      }
      case TagType.LABEL: {
        return theme.colors.white;
      }
      default: {
        return theme.colors.black;
      }
    }
  };

  const loadBgColorBasedOnItemType = () => {
    switch (type) {
      case TagType.NEW: {
        return theme.tagColors.new;
      }
      case TagType.ACTION: {
        return theme.tagColors.action;
      }
      case TagType.LASTONSTOCK: {
        return theme.tagColors.lastOnStock;
      }
      case TagType.LABEL: {
        return theme.tagColors.label;
      }

      default: {
        return 'transparent';
      }
    }
  };
  const color = loadColorBasedOnItemType();
  const bgColor = loadBgColorBasedOnItemType();

  return (
    <Wrapper style={style} color={color} bgColor={bgColor}>
      {text}
    </Wrapper>
  );
}

const Wrapper = styled.div<{ color: string; bgColor: string }>`
  height: ${rem(24)};
  padding: ${rem(3)} ${rem(12)};
  text-align: center;
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
  border-radius: ${rem(4)};
  font-size: ${rem(11)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: bold;
  text-transform: uppercase;
  margin-right: ${rem(8)};
  margin-bottom: ${rem(8)};
  ${({ theme }) => theme.mediab.s450`
    margin-bottom: ${rem(8)};
    height: auto;
    font-size: ${rem(10)};
    padding: ${rem(2)} ${rem(6)};
    white-space: nowrap;
  `}
`;

const withThemeTag: any = withTheme(Tag);
export { withThemeTag as Tag, TagType };
